import React, {useState} from 'react';
import ResizableTable from '../../components/table/ResizableTable';

const dataBase = [
    {
        id: 1,
        firstName: 'Andrea',
        lastName: 'Ross',
        username: '@andrea'
    },
    {
        id: 2,
        firstName: 'Penelope',
        lastName: 'Mills',
        username: '@Penelope'
    },
    {
        id: 3,
        firstName: 'Sarah',
        lastName: 'Johnson',
        username: '@sarah'
    },
    // {
    //     id: 4,
    //     firstName: 'Vanessa',
    //     lastName: 'Roberts',
    //     username: '@vanessa'
    // },
    // {
    //     id: 5,
    //     firstName: 'Oliver',
    //     lastName: 'Alsop',
    //     username: '@oliver'
    // },
    // {
    //     id: 6,
    //     firstName: 'Forsyth',
    //     lastName: 'Forsyth',
    //     username: '@jorsyth'
    // },
    // {
    //     id: 7,
    //     firstName: 'Michelle',
    //     lastName: 'King',
    //     username: '@michelle'
    // }
]

const Resizable = () => {
    const [data, setData] = useState([]);
    
    const atualizarTabela = () => {
        const tableDataNew = [];

        dataBase.forEach(dataBase => {
            const dataInserir = {...dataBase};

            dataInserir.actions = (
                <div>
                    <h3 onClick={() => alert(`A ${dataBase.id}`)}>A</h3>
                    {/* <h3 onClick={() => alert(`B ${dataBase.id}`)}>B</h3>
                    <h3 onClick={() => alert(`C ${dataBase.id}`)}>C</h3> */}
                </div>
            );

            tableDataNew.push(dataInserir);
        })

        setData(tableDataNew);
    }

    const tableStruct ={
        collumns: [
            {
                title: '',
                field: 'actions'
            },
            // {
            //     title: '#',
            //     field: 'id'
            // },
            {
                title: 'First Name',
                field: 'firstName',
                sort: true
            },
            {
                title: 'Last Name',
                field: 'lastName',
                sort: true
            },
            {
                title: 'Username',
                field: 'username'
            }
        ],
        idField: 'id',
        data: data,
        onCellDoubleClick: (obj) => alert(JSON.stringify(obj)),
        onCollumnMove: (colunas) => console.log('nova ordem', colunas),
        rowsPerPage: 3,
        startPage: 0,
        customLinesStyles: [
            {
                id: 1,
                style: {fontWeight: 'bolder'}
            },
            {
                id: 3,
                style: {backgroundColor: "#EAEAEA"}
            },
            {
                id: 5,
                style: {backgroundColor: "orange", fontWeight: 'bolder'}
            }
        ]
    }

    return(
        <div>
            <div onClick={atualizarTabela}>Carregar</div>
            <ResizableTable tableStruct={tableStruct}/>
        </div>
        
    )
}

export default Resizable;
